<template>
  <a-drawer
    :title="id ? '编辑音色' : '创建音色'"
    width="520"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item
        label="音色名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
        />
      </a-form-item>
      <!-- 原语种 -->
      <a-form-item
        label="原语种"
        name="source_lang_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.source_lang_id"
          placeholder="请选择"
          :disabled="!!id"
        >
          <!-- <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option> -->
          <a-select-option :key="1" :value="1">英文</a-select-option>
          <a-select-option :key="2" :value="2">中文</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 目标语种 -->
      <a-form-item
        label="目标语种"
        name="target_lang_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.target_lang_id"
          placeholder="请选择"
          :disabled="!!id"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="音频文件"
        name="audioFile"
        :rules="[{ required: !id, validator: validatorAudioFile }]"
      >
        <Upload
          accept=".mp3"
          uploadSource="TimbreAdd"
          :fileNumber="1"
          :fileList="formState.audioFile"
          :uploadBucket="$pub.BUCKET_TIMBRE()"
          :beforeUploadPro="beforeUploadPro"
          :uploadResult="uploadResult"
          :removePro="removePro"
          :disabled="!!id"
        >
          <template #up-title>上传文件（仅支持 .mp3）</template>
        </Upload>
        <div class="form-upload-hint" v-if="!id">仅支持 .mp3，后缀须小写</div>
        <div class="form-upload-list" v-if="formState.audioFile.length">
          <div
            class="form-upload-item form-upload-item--audio"
            v-for="(item, index) in formState.audioFile"
            :key="item.uid || index"
          >
            <span class="form-upload-name">{{ item.name || '音频' }}</span>
            <span v-if="item.status === 'uploading'" class="form-upload-status">上传中...</span>
            <template v-else-if="item.status === 'done'">
              <a class="form-upload-action" @click="touchPlayOrStop(item.url)">{{ playingUrl === item.url ? '停止' : '试听' }}</a>
              <a v-if="!id" class="form-upload-action" @click="touchDeleteAudio(index)">删除</a>
            </template>
            <template v-else>
              <a v-if="!id" class="form-upload-action" @click="touchDeleteAudio(index)">删除</a>
            </template>
          </div>
        </div>
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Upload from '@/components/Upload'
import Pub from '@/utils/public'
import { speechSave } from '@/api/admin'
import { langSearchList } from '@/api/admin'

const emit = defineEmits(['success'])
const RefForm = ref(null)
let visible = ref(false)
let isLoading = ref(false)
let id = ref(null)
let editRecord = ref(null)
let languages = ref([])
// 试听封装：同一时间只允许一个播放，传入新 url 会先停止再播
let audioInstance = ref(null)
let playingUrl = ref(null)
function audioPlayerPlay (url) {
  audioPlayerStop()
  if (!url) return
  const audio = new Audio(url)
  audioInstance.value = audio
  playingUrl.value = url
  audio.play().catch(() => {
    message.warning('播放失败')
    playingUrl.value = null
    audioInstance.value = null
  })
  audio.onended = () => {
    playingUrl.value = null
    audioInstance.value = null
  }
}
function audioPlayerStop () {
  if (audioInstance.value) {
    audioInstance.value.pause()
    audioInstance.value.currentTime = 0
    audioInstance.value = null
  }
  playingUrl.value = null
}
function touchPlayOrStop (url) {
  if (playingUrl.value === url) {
    audioPlayerStop()
  } else {
    audioPlayerPlay(url)
  }
}
let formState = reactive({
  name: undefined,
  source_lang_id: undefined,
  target_lang_id: undefined,
  url: undefined,
  vid: undefined,
  key: undefined,
  audioFile: []
})

function getSelectList () {
  langSearchList().then(res => {
    const { code, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
}

function showModal (params = {}) {
  visible.value = true
  id.value = params.id
  editRecord.value = params
  getSelectList()
  nextTick(() => {
    if (params.id) {
      formState.name = params.name
      formState.source_lang_id = params.source_lang_id
      formState.target_lang_id = params.target_lang_id
      formState.url = params.url
      formState.vid = params.vid
      formState.key = params.file_name
      formState.audioFile = params.url ? [{ uid: '-1', name: (params.file_name || '').split('/').pop(), status: 'done', url: params.url }] : []
    } else {
      formState.name = undefined
      formState.source_lang_id = undefined
      formState.target_lang_id = undefined
      formState.url = undefined
      formState.vid = undefined
      formState.key = undefined
      formState.audioFile = []
    }
  })
}

function onClose () {
  if (!isLoading.value) {
    audioPlayerStop()
    RefForm.value?.resetFields()
    id.value = undefined
    editRecord.value = null
    formState.source_lang_id = undefined
    formState.target_lang_id = undefined
    formState.url = undefined
    formState.vid = undefined
    formState.key = undefined
    formState.audioFile = []
    visible.value = false
  }
}

function validatorAudioFile () {
  if (!id.value && !formState.url) {
    return Promise.reject(new Error('请上传 .mp3 音频文件'))
  }
  return Promise.resolve()
}

function beforeUploadPro (file) {
  if (formState.audioFile.length >= 1) {
    message.warning('仅支持上传 1 个音频文件')
    return false
  }
  const name = file.name || ''
  if (!name.endsWith('.mp3')) {
    message.error('仅支持 .mp3 格式，且后缀必须为小写')
    return false
  }
  if (!file.type || !file.type.startsWith('audio/')) {
    message.error('请上传 .mp3 音频文件')
    return false
  }
  return true
}

function uploadResult (fileJson) {
  if (fileJson.status === 'done') {
    const { url, key, vid } = fileJson
    if (url) {
      formState.url = url
      formState.key = key ?? formState.key
      formState.vid = vid ?? formState.vid
      const idx = formState.audioFile.findIndex(f => f.uid === fileJson.uid)
      const doneItem = { uid: fileJson.uid, name: fileJson.name, status: 'done', url }
      if (idx !== -1) {
        formState.audioFile[idx] = { ...formState.audioFile[idx], url, status: 'done' }
      } else {
        formState.audioFile = [doneItem]
      }
    }
  }
}

function removePro (file) {
  const idx = formState.audioFile.findIndex(f => f.uid === file.uid)
  if (idx !== -1) {
    const item = formState.audioFile[idx]
    if (item.url === playingUrl.value) audioPlayerStop()
    const hadUrl = item.url === formState.url
    formState.audioFile.splice(idx, 1)
    if (hadUrl) {
      formState.url = undefined
      formState.key = undefined
    }
  }
  return true
}

function touchDeleteAudio (index) {
  const item = formState.audioFile[index]
  if (item && item.url === playingUrl.value) audioPlayerStop()
  const hadUrl = item && item.url === formState.url
  formState.audioFile.splice(index, 1)
  if (hadUrl) {
    formState.url = undefined
    formState.key = undefined
  }
}

function touchSubmit () {
  RefForm.value.validate().then(() => {
    const params = {
      name: formState.name,
      source_lang_id: formState.source_lang_id,
      target_lang_id: formState.target_lang_id,
      url: formState.url,
      vid: formState.vid || '',
      key: formState.key
    }
    if (id.value) params.id = id.value
    isLoading.value = true
    speechSave(params).then(res => {
      isLoading.value = false
      const { code, data, message: resMsg } = res
      if (code === 0 && data && data.result) {
        message.success('操作成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || resMsg || '操作失败')
      }
    }).catch(() => {
      isLoading.value = false
    })
  })
}

defineExpose({
  showModal
})
</script>

<style lang="less" scoped>
.form-upload-hint {
  padding-top: 6px;
  color: #8d8d8d;
  font-size: 12px;
}
.form-upload-list {
  margin-top: 10px;
}
.form-upload-item--audio {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
}
.form-upload-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-upload-status {
  color: #1890ff;
  font-size: 12px;
}
.form-upload-action {
  margin-left: 8px;
  font-size: 12px;
}
</style>
